import { useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY } from '../../../__generated__/chirp/com/hubspot/mylearning/bff/rpc/MyLearningBFFChirpService.dfc';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import getLang from '../../utils/getLang';
import { getQueryFieldName } from '../../utils/DataFetchingClientCache';
export const MY_LEARNING_QUERY_FIELD_NAME = getQueryFieldName(GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY);
export const useMyLearning = ({
  variables,
  skip
}) => {
  const {
    data: myLearningData,
    loading: myLearningDataLoading,
    error: myLearningDataError
  } = useQuery(GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY, {
    variables,
    skip
  });
  return {
    myLearningData,
    myLearningDataLoading,
    myLearningDataError
  };
};

// retrieves card models for the items retrieved by my learning BFF API
export const useMyLearningCardModels = variables => {
  // first retrieves elements to show
  const {
    myLearningData,
    myLearningDataLoading,
    myLearningDataError
  } = useMyLearning({
    variables
  });

  // then retrieves hydrated card models for the elements to render
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items: (myLearningData === null || myLearningData === void 0 ? void 0 : myLearningData.results.map(item => {
      const {
        id,
        type
      } = item;
      return {
        id: id,
        type: type,
        language: 'language' in item ? item.language : getLang().toUpperCase() // some progress comes back without language -> default to user's language
      };
    })) || [],
    skip: !myLearningData
  });
  return {
    myLearningCardModels: cardModels,
    myLearningCardModelsLoading: myLearningDataLoading || cardModelsLoading,
    myLearningCardModelsError: myLearningDataError || cardModelsError,
    totalCount: (myLearningData === null || myLearningData === void 0 ? void 0 : myLearningData.total) || 0
  };
};